module.exports = __webpack_public_path__ + "static/media/room-8.ebb7fca5.jpeg";